import React, { Component } from 'react';
import { withInjectedContext } from '../modules/2bap/2bap/decorators/withInjectedContext';
import { InformationPopupContext } from '../component/InformationPopupContext/InformationPopupContext';
import { first, omit, keys, each, isFunction } from 'lodash';

export const withRegisteredInfoPopup =
  
  /**
   * @param {Array<INFORMATION_POPUP_CONTEXT_CODES>} popupContextCodes
   * @param {boolean | function} showFirstPopup - boolean value or condition function to indicate whether the first popup from the provided list should be automatically shown on component mount
   * @return {function(*): WithInfoPopup}
   */
  (popupContextCodes = [], showFirstPopup = false) =>
  
  (WrappedComponent) => {
  
  @withInjectedContext(InformationPopupContext.childContextTypes)
  class WithInfoPopup extends Component {
    
    static propTypes = {
      ...InformationPopupContext.childContextTypes
    };
  
    componentWillMount() {
      each(popupContextCodes, code => { this.props.registerInformationPopupContextType(code); });
      
      if (!showFirstPopup) {
        return;
      }
      
      if (isFunction(showFirstPopup) && !showFirstPopup()) {
        return;
      }
  
      this.props.showInformationPopup(first(popupContextCodes));
    }
  
    componentWillUnmount() {
      each(popupContextCodes, code => { this.props.unregisterInformationPopupContextType(code); });
    }
    
    render() {
      return (
        <WrappedComponent
          {...omit(this.props, [keys(InformationPopupContext.childContextTypes)])}
        />
      );
    }
  
  }
  
  return WithInfoPopup;
  
};
